module.exports = __webpack_public_path__ + "static/media/3.4617b5a5.jpg";